import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import axios from "@dreamchimney/react-axios";
import { getSleevesByTag } from "~/api/getSleeves";

const RelatedTags = ({ tags = [] }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    if (!tags.length) {
      setItems([]);
      setLoading(false);
      return undefined;
    }

    const load = async () => {
      setLoading(true);
      try {
        // Existing /sleevery/search/tag returns { total } per tag
        const results = await Promise.all(
          tags.map(async (name) => {
            try {
              const response = await getSleevesByTag(axios, name, 1);
              const total = response.data && response.data.total;
              return { name, count: typeof total === "number" ? total : null };
            } catch (e) {
              console.log("failure:", e);
              return { name, count: null };
            }
          })
        );
        if (!cancelled) {
          setItems(results);
        }
      } catch (e) {
        console.log("failure:", e);
        if (!cancelled) {
          setItems(tags.map((name) => ({ name, count: null })));
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [tags.join("|")]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!tags.length) return null;

  return (
    <div className="related-tags">
      <h3 className="related-tags-header">
        <i className="fa fa-tags"></i> Related Tags
      </h3>
      {loading ? (
        <Skeleton count={2} />
      ) : (
        <ul className="list-unstyled related-tags-list">
          {items.map(({ name, count }) => (
            <li key={name}>
              <Link to={`/tag/${name}`}>{name}</Link>
              {count != null && <span className="related-tag-count"> ({count})</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RelatedTags;
